// extracted by mini-css-extract-plugin
module.exports = {"prodName":"prod-name_prodName__mGSMn","qknTheme":"prod-name_qknTheme__4zoaB","simpTheme":"prod-name_simpTheme__2r88o"};